import { stdObject } from "../../../../data/types/stdObject";
import { sendData } from "../../../../services/sendData";

export const toggleTaskStatus = async (
  notification: stdObject,
  index: number,
  { windowValues, setWindowValues, logoutAction }: stdObject,
) => {
  const active = notification.ESTTA0 ? 0 : 1;
  const payloadToggleTaskStatus = { id: notification.IDTA0, active };
  const responseToggleTaskStatus: stdObject = await sendData({
    endPoint: "updateTaskStatus",
    payload: payloadToggleTaskStatus,
    logoutAction,
  });

  if (responseToggleTaskStatus.success && responseToggleTaskStatus.status) {
    const notifications = [...windowValues.notifications];
    notifications[index] = { ...notifications[index], ESTTA0: active };
    setWindowValues({ ...windowValues, notifications });
  }
};
